import React, { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkshopDashboard from './components/WorkshopDashboard';
import TaskList from './components/TaskList';
import CarView from './components/CarView';
import { TabPanel } from '../../components/shared/TabPanel';
import { motion, AnimatePresence } from 'framer-motion';

const WorkshopPage = () => {
  const { t } = useTranslation('workshop');
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 2 }}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="workshop tabs"
            sx={{
              '& .MuiTab-root': {
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                }
              }
            }}
          >
            <Tab label={t('tabs.dashboard')} />
            <Tab label={t('tabs.myTasks')} />
            <Tab label={t('tabs.carView')} />
          </Tabs>
        </Box>

        <AnimatePresence mode="wait">
          <motion.div
            key={currentTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <TabPanel value={currentTab} index={0}>
              <WorkshopDashboard />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <TaskList />
            </TabPanel>

            <TabPanel value={currentTab} index={2}>
              <CarView />
            </TabPanel>
          </motion.div>
        </AnimatePresence>
      </Box>
    </Container>
  );
};

export default WorkshopPage;